import moment from "moment-timezone";

// Calendar dates stay dates; only actual instants are converted to salon time.
export const salonDate = (value = new Date(), timezone = "UTC") => {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const zone = moment.tz.zone(timezone) ? timezone : "UTC";
  return moment(value).tz(zone).format("YYYY-MM-DD");
};
